<template>
  <v-list dense style="padding-top: 0px !important;" flat>
    <v-subheader>
      {{ facilityName.toLowerCase() }} documents
    </v-subheader>
    <v-list-item v-if="!hideFloorplans"
                 :href="`https://dms.ipf.msu.edu/edms/?VIEWID=DOC_060DD&DOCFILTER=ae50dc&BUILDING=${this.facilityBuildingNo}`">
      <v-list-item-icon>
        <v-icon dense>mdi-magnify</v-icon>
        <v-icon dense>mdi-lock</v-icon>
      </v-list-item-icon>
      <v-list-item-title>search for pdf/dwg floorplans</v-list-item-title>
    </v-list-item>
    <v-list-item
        :href="`https://dms.ipf.msu.edu/edms/?VIEWID=DOC_712FA&DOCFILTER=8f8c7b&BUILDING=${this.facilityBuildingNo}`">
      <v-list-item-icon>
        <v-icon dense>mdi-magnify</v-icon>
        <v-icon dense>mdi-lock</v-icon>
      </v-list-item-icon>
      <v-list-item-title>search for project documents</v-list-item-title>
    </v-list-item>
    <v-list-item
        :href="`https://dms.ipf.msu.edu/edms/?VIEWID=DOC_049C6&DOCFILTER=d9ffd5&BUILDING=${this.facilityBuildingNo}`">
      <v-list-item-icon>
        <v-icon dense>mdi-magnify</v-icon>
        <v-icon dense>mdi-lock</v-icon>
      </v-list-item-icon>
      <v-list-item-title>search for project drawings</v-list-item-title>
    </v-list-item>
    <v-list-item
        :href="`https://dms.ipf.msu.edu/edms/?VIEWID=DOC_381BC&DOCFILTER=6f76c1&BUILDING=${this.facilityBuildingNo}`">
      <v-list-item-icon>
        <v-icon dense>mdi-magnify</v-icon>
        <v-icon dense>mdi-lock</v-icon>
      </v-list-item-icon>
      <v-list-item-title>search for equipment and material documents</v-list-item-title>
    </v-list-item>
    <v-list-item v-if="showOperationsFiles"
                 :href="`https://dms.ipf.msu.edu/BCEnterprise/?VIEWID=DOC_C8534&DOCFILTER=182b16&bldg=${this.facilityBuildingNo}`">
      <v-list-item-icon>
        <v-icon dense>mdi-magnify</v-icon>
        <v-icon dense>mdi-lock</v-icon>
      </v-list-item-icon>
      <v-list-item-title>search for electrical engineering operations files</v-list-item-title>
    </v-list-item>
    <v-list-item v-if="showOperationsFiles"
                 :href="`https://dms.ipf.msu.edu/BCEnterprise/?VIEWID=DOC_A2B02&DOCFILTER=3d0857&bldg=${this.facilityBuildingNo}`">
      <v-list-item-icon>
        <v-icon dense>mdi-magnify</v-icon>
        <v-icon dense>mdi-lock</v-icon>
      </v-list-item-icon>
      <v-list-item-title>search for central control operations files</v-list-item-title>
    </v-list-item>
    <v-list-item
        :href="`https://dms.ipf.msu.edu/edms/?VIEWID=DOC_47E40&DOCFILTER=9067df&BUILDING=${this.facilityBuildingNo}`">
      <v-list-item-icon>
        <v-icon dense>mdi-magnify</v-icon>
        <v-icon dense>mdi-lock</v-icon>
      </v-list-item-icon>
      <v-list-item-title>search for all documents</v-list-item-title>
    </v-list-item>
  </v-list>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "FacilityLinksDocuments",
  props: {
    facilityId: {
      type: String,
      required: true
    }
  },

  data: () => ({
    landEntity: null,
    facility: null
  }),

  computed: {
    facilityBuildingNo() {
      if (!this.facility && !this.landEntity) return ''

      return (this.facility) ? this.facility.building : this.landEntity.building
    },

    facilityName() {
      if (!this.facility && !this.landEntity) return ''

      return (this.facility) ? this.facility.name : this.landEntity.name
    },

    facilityType() {
      if (!this.facility && !this.landEntity) return ''

      return (this.facility) ? this.facility.structureType : this.landEntity.type || ''
    },

    hideFloorplans() {
      if (!this.facility && !this.landEntity) return true

      return (this.facilityType && ['DOCMANGMT', 'MAJORSYS'].indexOf(this.facilityType) >= 0)
    },

    showOperationsFiles() {
      if (!this.facility && !this.landEntity) return false

      return (this.facilityType && ['BUILDING', 'MISCSTRUCT'].indexOf(this.facilityType) >= 0)
    }
  },

  apollo: {
    landEntity: {
      query: gql`query ($landEntityId: String!){
          landEntity(where: {facilityId: {eq: $landEntityId}}){
              facilityId
              name
              building,
              type
          }
      }`,
      update: data => data.landEntity[0] || null,
      variables() {
        return {
          landEntityId: this.facilityId
        }
      }
    },
    facility: {
      query: gql`query ($facId: String!){
          facility(where: {facilityId: {eq: $facId}}){
              facilityId
              name
              building,
              structureType
          }
      }`,
      update(data) {
        let facility = null
        if (data.facility[0]) {
          facility = data.facility[0]
        }
        return facility
      },
      variables() {
        return {
          facId: this.facilityId
        }
      }
    }
  }
}
</script>

<style scoped>
.v-list-item__icon {
  height: 22px !important;
  margin: 0px !important;
  margin-right: .5em !important;
}

.v-list--dense .v-list-item, .v-list-item--dense {
  min-height: 20px;
  height: 24px;
}

.v-list-item__title {
  font-weight: 400 !important;
}
</style>
